import React from "react";
import { Wrapper } from "@/components/Wrapper";
import { BenefitsList } from "../BenefitsList";
import { PlanWrapper } from "../PlanWrapper";
import { renderPhoneBox } from "@/utils/pricing";
import { SubscriptionPlansLoggedProps } from "../types";

export const SubscriptionPlansLogged = ({
  data,
  currentPlan,
  onSelectPlan,
  isStatusActive,
}: SubscriptionPlansLoggedProps) => {
  return (
    <>
      <div className="subscription-plans-logged__container">
        <Wrapper customClass="userLogged">
          <PlanWrapper
            data={data}
            currentPlan={currentPlan}
            onSelectPlan={onSelectPlan}
            isStatusActive={isStatusActive}
            customClass={"plan-wrapper__userLogged"}
          />
        </Wrapper>

        {renderPhoneBox(data, "middle", true)}

        <div
          className="dynamic-benefits__userLogged"
          id="dynamic-benefits__userLogged">
          <div className="dynamic-benefits__wrapper">
            <BenefitsList
              list={currentPlan?.benefits?.richtext?.list}
              active={true}
            />
          </div>
        </div>
      </div>

      {renderPhoneBox(data, "bottom", true)}
    </>
  );
};
